/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Task_Save_DescInputs */

const en_pc_online_task_save_desc = /** @type {(inputs: Pc_Online_Task_Save_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Press ⌘S. In the browser the saved PDF arrives as a download, so look in your Downloads folder. Changes are appended, so the original content of the file is kept.`)
};

const zh_pc_online_task_save_desc = /** @type {(inputs: Pc_Online_Task_Save_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按 ⌘S。在浏览器中，保存的 PDF 会以下载的形式交给你，请到「下载」文件夹中查找。修改以追加方式写入，文件的原始内容会被保留。`)
};

/**
* | output |
* | --- |
* | "Press ⌘S. In the browser the saved PDF arrives as a download, so look in your Downloads folder. Changes are appended, so the original content of the file is ..." |
*
* @param {Pc_Online_Task_Save_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_task_save_desc = /** @type {((inputs?: Pc_Online_Task_Save_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Task_Save_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_task_save_desc(inputs)
	return zh_pc_online_task_save_desc(inputs)
});
export { pc_online_task_save_desc as "pc.online.task.save.desc" }